module.exports = __webpack_public_path__ + "static/media/CermonyPoster.d4171197.jpg";